import type { SessionUser } from '#src/shared/session';

import { useCurrentUserAsync } from '#src/app/shared/hooks/session';
import { isLoaded, isLoading } from '#src/app/shared/utils/async';

type Comment = { user: { id: string } };

type Result = { canReportComment: boolean; currentUser: SessionUser | undefined };

export function useCanReportComment(comment: Comment | null): Result {
	const currentUserBase = useCurrentUserAsync();

	let canReportComment = false;

	if (!isLoading(currentUserBase) && comment) {
		const isCommentOwner = currentUserBase.value?.id === comment.user.id;
		canReportComment = !isCommentOwner;
	}

	return {
		canReportComment,
		currentUser: isLoaded(currentUserBase) ? currentUserBase.value : undefined,
	};
}
